import React, {FC, useState} from 'react'
import {KTCard, KTCardBody} from '../../../../../../../_metronic/helpers'
import {Col, Row} from 'react-bootstrap'
import {Button} from '../../../../../components/UI/Button'
import {CheckingModel} from '../../../models/ckecking.model'
import Swal from 'sweetalert2'
import {createCheckoutService, getCheckingService2} from '../../../services/checking.service'
import {getSnackBar, getSnackBarToast} from '../../../../../util/snackBar'
import {downloadPDFCheckInOutService} from '../../../services/booking.service'
import moment from 'moment'
import {ModalCheckoutApp} from '../modal/ModalCheckoutApp'

interface Props {
  isChecked: boolean
  checkin: CheckingModel | null
  getCheckings: () => void
}

const CheckoutCardApp: FC<Props> = ({isChecked, checkin, getCheckings}) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [bookingChecked, setBookingChecked] = useState<CheckingModel | null>(null)

  const handleCheckout = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'De realizar esta accion?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const {data: response} = await createCheckoutService({
          ReservaId: checkin?.ReservaId as string,
          CamaId: checkin?.CamaId as string,
          HuespedId: checkin?.HuespedId as string,
        })
        if (!response.error) {
          const {data: response2} = await getCheckingService2({
            pageNumber: 1,
            size: 10,
            ReservaCamaId: response.ReservaCamaId,
          })
          if (!response2.error) {
            setBookingChecked(response2.data[0])
            setShowModal(true)
          }
        } else {
          getSnackBarToast('Hubo un error al hacer checkout', 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleDownload = async () => {
    try {
      let dto = {
        reservaCamaId: checkin?.ReservaCamaId,
        tipo: 'OUT',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckOut-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <Col lg={4} xs={12} md={6}>
      <KTCard className='shadow-sm m-2'>
        <h4 className='d-flex align-items-center ps-6 pt-6 pe-6'>
          Codigo de Reserva : {`${checkin?.CodigoReserva}`}
        </h4>
        <KTCardBody>
          {isChecked && (
            <>
              <Row>
                <h5 className='text-success'>Checkout Realizado</h5>
              </Row>
            </>
          )}
          <Row>
            <Col>
              <strong>Fecha/hora checkin: </strong>
            </Col>
            <Col>
              <span>{checkin?.FechaCheckIn}</span>
            </Col>
          </Row>
          {isChecked && (
            <Row>
              <Col>
                <strong>Fecha/hora checkout: </strong>
              </Col>
              <Col>
                <span>{checkin?.FechaCheckOut}</span>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <strong>Fecha ingreso programada: </strong>
            </Col>
            <Col>
              <span>{checkin?.FechaInicio}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <strong>Fecha salida programada: </strong>
            </Col>
            <Col>
              <span>{checkin?.FechaFin}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <strong>Site: </strong>
            </Col>
            <Col>
              <span>{checkin?.Site}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <strong>Campamento: </strong>
            </Col>
            <Col>
              <span>{checkin?.Campamento}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <strong>Módulo: </strong>
            </Col>
            <Col>
              <span>{checkin?.Modulo}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <strong>Habitación: </strong>
            </Col>
            <Col>
              <span>{checkin?.Habitacion}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <strong>Cama: </strong>
            </Col>
            <Col>
              <span>{checkin?.CodigoCama}</span>
            </Col>
          </Row>
          <div className='d-flex justify-content-center'>
            {isChecked ? (
              <Button
                label='Descargar Ticket Checkout'
                classNameProp='mt-6'
                onClick={handleDownload}
              />
            ) : (
              <Button label='Checkout' classNameProp='mt-6' onClick={handleCheckout} />
            )}
          </div>
        </KTCardBody>
      </KTCard>
      {showModal ? (
        <ModalCheckoutApp
          show={showModal}
          setShow={setShowModal}
          getChekings={getCheckings}
          checkin={bookingChecked}
        />
      ) : (
        <></>
      )}
    </Col>
  )
}

export default CheckoutCardApp
